import React, { useCallback, useMemo, useState } from 'react';

import { FeeModal } from './FeeModal';
import { FeeModalInfo, ShowFeeModalParams, UseFeeModalReturn } from './types';

export const useFeeModal = (): UseFeeModalReturn => {
  const [open, setOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState<FeeModalInfo | null>(null);

  const closeFeeModal = useCallback(() => setOpen(false), []);

  const showFeeModal = useCallback((params: ShowFeeModalParams) => {
    setModalInfo(params);
    setOpen(true);
  }, []);

  const portal = useMemo(() => {
    if (!open || !modalInfo) return null;

    return (
      <FeeModal
        open={open}
        onClose={closeFeeModal}
        title={modalInfo.title}
        infoCopy={modalInfo.infoCopy}
        feeLines={modalInfo.feeLines}
        footNote={modalInfo.footNote}
      />
    );
  }, [open, modalInfo, closeFeeModal]);

  return {
    showFeeModal,
    closeFeeModal,
    FeeModalPortal: portal,
  };
};

export default useFeeModal;
